/**
 * Stub for the file uploader form view. Just an outline of ideas
 * right now.
 * @constructor
 * @param {jQuerySelector} element
 * @extends {Foundation.View}
 */
Foundation.Form.FileInput = function (element) {
  Foundation.View.call(this, element);

  // Let's set this up to do things, like:
  //   * Hook up events to the iframe
  //   * Keep hidden input in sync
  //   * Find a way to ensure form's submit
  //     delegate is not run until we're done
  //     uploading
};
Foundation.inherit(Foundation.Form.FileInput, Foundation.View);
